/**
 * Frontend brand configuration.
 *
 * Core values (appName, colors, Bundesländer, categories) come from @radevents/shared.
 * This file adds frontend-specific config (logo, sidebar colors).
 */

// Re-export shared brand constants
export {
  brand,
  brandColors,
  BUNDESLAENDER,
  BUNDESLAENDER_AT,
  BUNDESLAENDER_CH,
  BUNDESLAENDER_BY_COUNTRY,
  FOREIGN_COUNTRIES,
  FOREIGN_REGIONS,
  REGION_GROUPS,
  ALL_REGIONS,
  CORE_COUNTRIES,
  COUNTRY_LABELS,
  displayBundesland,
  countryOfBundesland,
  regionsOfCountry,
  postalCodeDigits,
  postalCodeRegionWarning,
  CATEGORY_LABELS,
  tokens,
  CATEGORY_COLORS,
  STAGE_TYPE_COLORS,
  fonts,
} from '@radevents/shared';
export type { CountryCode } from '@radevents/shared';

/**
 * Logo config (frontend-only, not relevant for mobile)
 */
export const logoConfig = {
  // Logo: import an SVG/PNG or set to null to use text-only
  // Example: import logo from '../assets/logo.svg';
  logo: null as string | null,
  logoSize: { width: 32, height: 32 },
} as const;

/**
 * Sidebar color scheme.
 */
export const sidebarColors = {
  background:       '#1e293b',
  headerBorder:     '#334155',
  brandText:        '#60a5fa',
  linkText:         '#cbd5e1',
  linkHover:        '#334155',
  linkActiveBg:     '#1e40af',
  linkActiveBorder: '#60a5fa',
  footerBorder:     '#334155',
  avatarBg:         '#60a5fa',
  roleText:         '#94a3b8',
  menuBg:           '#334155',
  menuHover:        '#475569',
} as const;
